module.exports = __webpack_public_path__ + "static/media/values.3703ef3e.svg";